<template>
  <div class="header-mobile row">
    <!-- Header Mobile -->
    <div
      v-if="displayMenuButton"
      class="main-menu-icon-toggled"
      @click.stop="toggleMenu()"
    >
      <feather-icon icon="MenuIcon" class="menu-icon" />
    </div>

    <feather-icon
      v-if="displayBackButton"
      icon="ChevronLeftIcon"
      @click.stop="onBack"
      class="menu-icon"
      svg-classes=""
    ></feather-icon>

    <div
      class="text-filter-btn"
      @click.stop="openInformativeContentFilter()"
      v-if="displayInformativeItens"
    >
      <div class="name-category">
        {{ textInformativeContentFilter
        }}<feather-icon
          icon="ChevronDownIcon"
          class="chev"
          :svgClasses="['chev']"
        ></feather-icon>
      </div>
    </div>
    <div
      class="text-filter-btn"
      @click.stop="openInformativeContentFilter()"
      v-if="displayTitle"
    >
      <div class="header-mobile-title">{{ title }}</div>
    </div>

    <!-- Search -->
    <!-- <feather-icon icon="SearchIcon" class="search-icon" svgClasses="h-5 w-5" />
    <feather-icon icon="ChevronDownIcon" class="chevron-down-icon" svgClasses="h-4 w-4" /> -->
    <!-- <div class="informative-input-search-mobile d-theme-dark-bg" :class="{'input-search-mobile-focused': displaySearchInput}" v-if="displayInformativeItens">
      <vs-input
        id="input-search-mobile"
        icon-no-border
        icon="icon-search"
        size="large"
        icon-pack="feather"
        :placeholder="$t('REPORT_FILTER').Search"
        v-model="searchQuery"
        class="vs-input-no-border vs-input-no-shdow-focus w-full"
        v-on:keyup.enter="searchAll()"
      />
      <feather-icon class="cursor-pointer close-icon" icon="XIcon" :svgClasses="['h-5 w-5']" @click="clearSearchQuery()"></feather-icon>
    </div> -->

    <div class="buttons-header flex">
      <div
        ref="filterBadgeMobile"
        class="btn-header-mobile"
        v-if="displayInformativeItens && !currentContent.isQuotes"
        @click.stop="openInformativeFilter()"
      >
        <!-- <feather-icon class="cursor-pointer" icon="SearchIcon" :svgClasses="['ml-2']" >
        </feather-icon> -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-search"
        >
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
        <vs-chip
          v-if="filterSelected"
          class="number informative-filter-badge-mobile"
          color="primary"
        ></vs-chip>
      </div>
      <div
        class="btn-header-mobile"
        @click.stop="refreshReports"
        v-if="displayInformativeItens && !currentContent.isQuotes"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="15"
          :class="[refreshActive ? 'rotate-button' : '']"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="23 4 23 10 17 10"></polyline>
          <polyline points="1 20 1 14 7 14"></polyline>
          <path
            d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
          ></path>
        </svg>
      </div>
      <!-- Mobile filter button -->
      <div
        class="btn-header-mobile playlist"
        @click.stop="openPlaylist()"
        v-if="displayInformativeItens"
      >
        <!-- <feather-icon icon="PlaylistIcon" :svgClasses="['icon-white icon-playlist']" /> -->
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" class="feather icon-white icon-playlist"><g transform="translate(-376 -423)"><g transform="translate(377 424)"><path d="M11.036,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H11.036a1,1,0,0,1,1,1A1,1,0,0,1,11.036,1Z" transform="translate(4.245 0)"></path><path d="M3.806,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H3.806a1,1,0,0,1,1,1A1,1,0,0,1,3.806,1Z" transform="translate(4.244 5.093)"></path><path d="M3.806,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H3.806a1,1,0,0,1,1,1A1,1,0,0,1,3.806,1Z" transform="translate(4.244 10.188)"></path><path d="M.008,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H.008a1,1,0,0,1,1,1A1,1,0,0,1,.008,1Z" transform="translate(0 0)"></path><path d="M.008,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H.008a1,1,0,0,1,1,1A1,1,0,0,1,.008,1Z" transform="translate(0 5.094)"></path><path d="M.008,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H.008a1,1,0,0,1,1,1A1,1,0,0,1,.008,1Z" transform="translate(0 10.187)"></path></g><path d="M5,3,8.961,7.049,5,11.1Z" transform="translate(384.411 425.101)"></path><path d="M5,2a1,1,0,0,1,.715.3L9.676,6.35a1,1,0,0,1,0,1.4L5.715,11.8A1,1,0,0,1,4,11.1V3A1,1,0,0,1,5,2ZM7.562,7.049,6,5.452V8.646Z" transform="translate(384.411 425.101)"></path></g></svg> -->
        <feather-icon
          icon="ArchiveIcon"
          :svgClasses="['h-7 w-7']"
        ></feather-icon>
      </div>
    </div>
    <!-- End of Mobile filter button -->
    <!-- End of Header Mobile -->
  </div>
</template>

<script>
import { EventBus } from "../../event-bus";
import AppConstants from "../../appConstants";
import { is } from "vuejs-datepicker/src/locale";
export default {
  data() {
    return {
      displayMenuButton: false,
      displayBackButton: false,
      filterSelected: false,
      displayInformativeItens: false,
      textInformativeContentFilter: "TODOS",
      displaySearchInput: false,
      searchQuery: "",
      title: "",
      displayTitle: false,
    };
  },
  methods: {
    refreshReports() {
      EventBus.$emit(AppConstants.BUS_EVENT_REFRESH);
    },
    checkDisplayExclusiveContent() {
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_EXCLUSIVE_CONTENT_POPUP);
    },
    onBack() {
      EventBus.$emit(AppConstants.BUS_EVENT_HEADER_MOBILE_BACK);
    },
    openPlaylist() {
      if (this.isAuthenticated) {
        EventBus.$emit(AppConstants.BUS_EVENT_OPEN_PLAYLIST, true);
      } else {
        EventBus.$emit(AppConstants.BUS_EVENT_OPEN_EXCLUSIVE_CONTENT_POPUP);
      }
    },
    displaySearch() {
      this.displaySearchInput = true;
      document.getElementById("input-search-mobile").focus();
    },
    clearSearchQuery() {
      (this.searchQuery = ""), (this.displaySearchInput = false);
      this.searchAll();
    },
    searchAll() {
      EventBus.$emit(
        AppConstants.BUS_EVENT_SEARCH_INFORMATIVE_MOBILE,
        this.searchQuery
      );
    },
    toggleMenu() {
      EventBus.$emit(AppConstants.BUS_EVENT_HEADER_MOBILE_OPEN_MAIN_MENU, true);
    },
    openInformativeFilter() {
      if (!this.isAuthenticated) {
        this.checkDisplayExclusiveContent();
        return;
      }
      EventBus.$emit(
        AppConstants.BUS_EVENT_HEADER_MOBILE_OPEN_INFORMATIVE_FILTER,
        true
      );
    },
    openInformativeContentFilter() {
      EventBus.$emit(
        AppConstants.BUS_EVENT_HEADER_MOBILE_OPEN_INFORMATIVE_CONTENT_FILTER,
        true
      );
    },
    checkDisplayItem() {
      this.displayInformativeItens = this.$route.name == "informative";
      if (
        this.$route.name == "my-account" ||
        this.$route.name == "change-password"
      ) {
        this.displayTitle = true;
        this.displayBackButton = true;
        this.displayMenuButton = false;
      } else {
        this.displayTitle = false;
        this.displayBackButton = false;
        this.displayMenuButton = true;
      }
    },
  },
  watch: {
    "$route.name"() {
      this.checkDisplayItem();
    },
  },
  computed: {
    currentContent() {
      return this.$store.state.currentContent;
    },
    contentPrivate() {
      return this.$store.state.contentPrivate || { text: "" };
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
    isDesktop() {
      return this.$store.state.isDesktop;
    },
    refreshActive() {
      return this.$store.state.refreshActive;
    },
  },
  mounted() {
    this.searchQuery = this.$route.query.q;

    EventBus.$on(AppConstants.BUS_EVENT_UPDATE_NUM_FILTER_MOBILE, (filter) => {
      this.filterSelected = filter;
    });

    EventBus.$on(
      AppConstants.BUS_EVENT_HEADER_MOBILE_SELECT_INFORMATIVE_CONTENT_FILTER,
      (contentName) => {
        this.textInformativeContentFilter = contentName;
      }
    );

    EventBus.$on(AppConstants.BUS_EVENT_HEADER_MOBILE_TITLE, (data) => {
      this.title = data;
    });

    this.checkDisplayItem();

    if (this.$store.state.insetTop) {
      let styleTag = document.getElementById("con-vs-chip-number-overrides");
      if (!styleTag) {
        styleTag = document.createElement("style");
        styleTag.id = "con-vs-chip-number-overrides";
        document.head.appendChild(styleTag);
      }
      styleTag.textContent = `
      .btn-header-mobile .con-vs-chip.number{
        top: ${21 + Number(this.$store.state.insetTop)}px !important;
      }

    `;
    }
  },
  beforeDestroy() {
    EventBus.$off(AppConstants.BUS_EVENT_UPDATE_NUM_FILTER_MOBILE);
    EventBus.$off(
      AppConstants.BUS_EVENT_HEADER_MOBILE_SELECT_INFORMATIVE_CONTENT_FILTER
    );
    EventBus.$off(AppConstants.BUS_EVENT_HEADER_MOBILE_TITLE);
  },
};
</script>

<style lang="scss">
.filter-btn-center-mobile {
  margin: auto;
  width: 140px;
  right: 50%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;

  .feather-icon {
    position: absolute !important;
    margin-top: -2px !important;
  }
}
.informative-input-search-mobile {
  transition: width 0.4s;
  z-index: 99999;
  position: absolute;
  width: 0;
  height: 51px;

  .vs-con-input {
    display: none;
  }

  .close-icon {
    margin-top: 0px !important;
    margin-right: 10px;
    display: none;
  }
}
.input-search-mobile-focused {
  width: 100%;
  display: flex;

  .vs-con-input {
    display: flex;
  }

  .close-icon {
    display: flex;
  }
}
.filter-btn-center-mobile {
  margin: auto;
  width: 140px;
  right: 50%;
  position: fixed;
  top: 20px;
  left: 50%;
  text-transform: uppercase;
  transform: translate(-50%, -50%);
  text-align: center;

  .feather-icon {
    position: absolute !important;
    margin-top: -1px !important;
  }
}
.search-btn-icon-mobile {
  position: absolute;
  top: 14px;
  right: 0;
  margin-right: 47px;
  .feather-icon {
    width: 22px;
  }
}
</style>
